import React from 'react';
import FooterNotes from './footerNotes';
import FooterMenu from './footerMenu';
import FooterFooter from './footerFooter';

const Footer = () => (
  <footer className="footer">
    <FooterNotes />
    <FooterMenu />
    <FooterFooter />
  </footer>
);

export default Footer;
